import Emitter from 'tiny-emitter';

function getEventBus() {
  const emitter = new Emitter();
  return {
    $on: (...args) => emitter.on(...args),
    $once: (...args) => emitter.once(...args),
    $off: (...args) => emitter.off(...args),
    $emit: (...args) => emitter.emit(...args)
  };
}

export default getEventBus;
